import { UsersIcon } from '../common/icons.jsx';

const AVATAR_COLORS = [
  'bg-[#1e40af]', 'bg-[#059669]', 'bg-[#f97316]', 'bg-[#dc2626]',
  'bg-[#0891b2]', 'bg-purple-600', 'bg-pink-600', 'bg-amber-600',
];

/**
 * Table showing per-driver delivery stats with avatar initials.
 * @param {{ drivers: Array<{ driverName: string, count: number, avgTime: number|null, deliveredUnits: number, unitsPerHour: number|null, problemCount: number, manualScans: number }> }} props
 */
export default function DriverTable({ drivers }) {
  if (!drivers || drivers.length === 0) {
    return (
      <div className="bg-white rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-[#0f172a] mb-2">Stats par livreur</h3>
        <p className="text-sm text-[#64748b]">Aucune donnée de livraison.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <UsersIcon size={18} className="text-[#1e40af]" />
        <h3 className="font-semibold text-[#0f172a]">Stats par livreur</h3>
      </div>
      <div className="overflow-x-auto -mx-1">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-left text-[#64748b] text-xs">
              <th className="pb-3 pl-1">Livreur</th>
              <th className="pb-3 text-right">Livrés</th>
              <th className="pb-3 text-right">Temps</th>
              <th className="pb-3 text-right">Unités/h</th>
              <th className="pb-3 text-right">Prob.</th>
              <th className="pb-3 text-right pr-1">Manuel</th>
            </tr>
          </thead>
          <tbody>
            {drivers.map((d, i) => {
              const initials = d.driverName
                .split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);
              const avatarColor = AVATAR_COLORS[i % AVATAR_COLORS.length];
              return (
                <tr key={i} className="border-b border-gray-50 last:border-0">
                  <td className="py-3 pl-1">
                    <div className="flex items-center gap-2">
                      <div className={`w-7 h-7 rounded-full ${avatarColor} text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0`}>
                        {initials}
                      </div>
                      <span className="font-medium text-[#0f172a] truncate">{d.driverName}</span>
                    </div>
                  </td>
                  <td className="py-3 text-right text-[#0f172a]">{d.count}</td>
                  <td className="py-3 text-right text-[#64748b]">
                    {d.avgTime ? `${Math.round(d.avgTime)}m` : '\u2014'}
                  </td>
                  <td className="py-3 text-right text-[#64748b]">
                    {d.unitsPerHour != null ? d.unitsPerHour : '\u2014'}
                  </td>
                  <td className="py-3 text-right">
                    <span className={d.problemCount > 0 ? 'text-[#dc2626] font-medium' : 'text-[#64748b]'}>
                      {d.problemCount ?? 0}
                    </span>
                  </td>
                  <td className="py-3 text-right pr-1 text-[#64748b]">{d.manualScans ?? 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
